import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['clients--image-rotator']

  rotateAllLeft(event) {
    event.preventDefault()
    this.clientsImageRotatorOutlets.forEach((outlet) => outlet.rotateLeft())
  }

  rotateAllRight(event) {
    event.preventDefault()
    this.clientsImageRotatorOutlets.forEach((outlet) => outlet.rotateRight())
  }
}
